<script>
    import { createEventDispatcher, onDestroy, onMount } from "svelte";
    import { showDebug } from "../stores.js";

    const dispatch = createEventDispatcher();
    const close = () => dispatch("close");
    const ok = () => {
        if (!dataError) {
            dispatch("ok");
        }
    }
    const json = () => {
        if (toggleJson) {
            toggleJson = !toggleJson;
            dispatch("json");
        }
    };

    let modal;
    export let wide = false;
    export let okable = true;
    export let cancellable = true;
    export let dataError = false;
    export let jsonable = false;
    let toggleJson = jsonable || false;

    const handle_keydown = (e) => {
        if (e.key === "Escape") {
            close();
            return;
        }

        if (e.key === "Tab") {
            // trap focus
            const nodes = modal.querySelectorAll("*");
            const tabbable = Array.from(nodes).filter((n) => n.tabIndex >= 0);

            let index = tabbable.indexOf(document.activeElement);
            if (index === -1 && e.shiftKey) index = 0;

            index += tabbable.length + (e.shiftKey ? -1 : 1);
            index %= tabbable.length;

            tabbable[index].focus();
            e.preventDefault();
        }
    };

    const previously_focused = typeof document !== "undefined" && document.activeElement;

    if (previously_focused) {
        onDestroy(() => {
            previously_focused.focus();
        });
    }
</script>

<svelte:window on:keydown={handle_keydown} />

<div class="modal-background" on:click={close} />

<div class="modal {wide ? 'wide' : ''}" role="dialog" aria-modal="true" bind:this={modal}>
    <slot name="header" />
    <!--hr-->
    <slot />
    <hr />

    {#if dataError}
        <p class='error'>{dataError.msg}</p>
    {/if}

    <button-bar>
        {#if okable}
            <button class:disabled={dataError} on:click={ok}>OK</button>
        {/if}
        {#if cancellable}
            <!-- svelte-ignore a11y-autofocus -->
            <button autofocus on:click={close}>Cancel</button>
        {/if}
        {#if $showDebug && jsonable}
            <button class:disabled={!toggleJson} on:click={json}>JSON</button>
        {/if}
    </button-bar>
</div>

<style>
    .modal-background {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.3);
        z-index: 5;
    }

    .modal {
        position: absolute;
        left: 50%;
        top: 50%;
        width: calc(100vw - 4em);
        max-width: 32em;
        max-height: calc(100vh - 4em);
        overflow: auto;
        transform: translate(-50%, -50%);
        padding: 1em;
        border-radius: 0.2em;
        background: white;
        z-index: 5;
        /*white-space: nowrap;*/
        text-align: left;
    }

    .wide {
        max-width: 100%;
    }

    .error {
        color: red;
    }

    :global(body.dark) .modal {
        background: #333;
    }

    button-bar {
        display: flex;
        flex-direction: row;
        gap: 16px;
    }
</style>
